import React from 'react';
import { Link } from 'react-router-dom';
import './LiveMusicPromo.css';
import liveMusicPoster from '../assets/live-music/live-music-poster.png';

const LiveMusicPromo = () => {
  return (
    <section className="live-music-promo">
      <Link to="/live-music" className="live-music-promo-poster-link">
        <img
          className="live-music-promo-poster"
          src={liveMusicPoster}
          alt="Drake's San Carlos Live Music every Thursday at 6 PM"
        />
      </Link>

      <div className="live-music-promo-text">
        <div className="live-music-promo-eyebrow">Weekly at Drake's</div>
        <h2 className="live-music-promo-title">Live Music</h2>
        <div className="live-music-promo-time">Every Thursday at 6 PM</div>
        <p>
          Local musicians, no cover, and our full dinner menu and craft cocktails all night.
          Musicians — bookings are open.
        </p>
        <div className="live-music-promo-buttons">
          <Link to="/live-music" className="live-music-promo-button">See Details</Link>
          <Link to="/reservations" className="live-music-promo-button secondary">Reserve a Table</Link>
        </div>
      </div>
    </section>
  );
};

export default LiveMusicPromo;
